import React, {
  createContext,
  useContext,
} from "react";
import PropTypes from "prop-types";

const SharedTranslationContext = createContext({});

export const SharedTranslationProvider = ({ useTranslation, children }) => {
  return (
    <SharedTranslationContext.Provider value={{ _useTranslation: useTranslation }}>
      {children}
    </SharedTranslationContext.Provider>
  );
};

SharedTranslationProvider.propTypes = {
  i18nInstance: PropTypes.object,
};

const useSharedTranslationContext = () => useContext(SharedTranslationContext);

/**
 * @returns {{
    playChapterAndShowPlayer: (
      id: string,
      startTime?: number,
      options?: {
        fromML?: boolean,
        onError?: function,
      }
    ) => void,
    setActiveChapter: function,
    playChapterAndShowPlayerIfNotTheSameBook: function,
    toggleChapterPlaying: function,
    seekPlayer: function,
    skipPlayer: function,
    stopPlayer: function,

    getPlayer: function,
    getPlayerCurrentTime: function,
    setPlayerCurrentTime: function,
    updatePlayerState: function,
    updatePlaybackRate: function,
    downloadOrPullFromSWWaveformsData: function,
    savePlayPosition: function,

    subscribeToPlayerEvents: function,
    unsubscribeFromPlayerEvents: function,

    chapterId: string,
    volume: number,
    duration: number,
    isPlaying: boolean,
    stopTimeout: number,
    isMute: boolean,
    playbackRate: number,

    fileDuration: number|undefined,
    trackTitle: string,
    canSeekBack: boolean,
    canSeekForward: boolean,
    isBroken: boolean,

    audioChapterId: string|undefined,
    audioChapter: {}|null,
    waveform: {}|null,
    waveformsDictionary: {},
    paragraphsAudioPositions: []|null,
    audioChapters: {}[],
    currPrevNextChapters: CurrPrevNextChapters,
    toc: {}[],
    book: {},
 * }}
 */
export const useSharedTranslation = () => {
  const { _useTranslation } = useSharedTranslationContext();

  return _useTranslation();
};
